"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#F6E7F6",
  d: "M4 5h3v.75h6V5h3.25v4.125L11.875 12.5 11.5 14l1.125.375 3.625-2.625V17H4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CE3BCE",
  fillRule: "evenodd",
  d: "M6.975 2.4a.7.7 0 0 0-.7.7v.5h-2.6a.7.7 0 0 0-.7.7v12.6a.7.7 0 0 0 .7.7h12.6a.7.7 0 0 0 .7-.7v-2.1a.7.7 0 1 0-1.4 0v1.4h-11.2V5h1.9v.6a.7.7 0 0 0 .7.7h6a.7.7 0 0 0 .7-.7V5h1.9v.9a.7.7 0 1 0 1.4 0V4.3a.7.7 0 0 0-.7-.7h-2.6v-.5a.7.7 0 0 0-.7-.7zm.7 2.5V3.8h4.6v1.1zm-.7 3.3a.7.7 0 1 0 0 1.4h4.32a.7.7 0 1 0 0-1.4zm0 2.357a.7.7 0 1 0 0 1.4h1.964a.7.7 0 1 0 0-1.4zm0 2.357a.7.7 0 1 0 0 1.4h1.57a.7.7 0 1 0 0-1.4zm9.468-5.216a.7.7 0 0 1 .982.12l1.451 1.858a.7.7 0 0 1-.12.982l-5.013 3.917a.7.7 0 0 1-.434.148l-1.904-.008a.7.7 0 0 1-.677-.866l.453-1.85a.7.7 0 0 1 .249-.385zm.31 1.534-4.27 3.336-.184.75.773.004 4.27-3.336z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=FormsColorIcon20.js.map